<template>
  <!--Header-->
  <header id="header" class="sticky-top-slide">
    <!-- Navbar -->
    <nav
      class="primary-menu navbar navbar-expand-lg text-uppercase navbar-line-under-text fw-600"
    >
      <div class="container position-relative">
        <div class="col-auto col-lg-2 d-inline-flex ps-lg-0">
          <!-- Logo -->
          <router-link
            to="/"
            class="text-decoration-none display-6 fw-bold logo"
            >Bhavin</router-link
          >
          <!-- Logo End -->
        </div>
        <div class="col col-lg-8 navbar-accordion px-0">
          <button
            class="navbar-toggler ms-auto"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#header-nav"
          >
            <span></span><span></span><span></span>
          </button>
          <div
            id="header-nav"
            class="collapse navbar-collapse justify-content-center"
          >
            <ul class="navbar-nav">
              <li class="nav-item">
                <router-link to="/">
                  <a class="nav-link smooth-scroll active" href="#home">Home</a>
                </router-link>
              </li>
              <li class="nav-item">
                <a :href="base_url + '#about'" class="nav-link smooth-scroll"
                  >About</a
                >
              </li>
              <li class="nav-item">
                <a class="nav-link smooth-scroll" :href="base_url + '#services'"
                  >Services</a
                >
              </li>
              <li class="nav-item">
                <a class="nav-link smooth-scroll" :href="base_url + '#resume'"
                  >Resume</a
                >
              </li>
              <li class="nav-item">
                <router-link
                  to="/portfolio"
                  class="nav-link smooth-scroll"
                  >Portfolio</router-link
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link smooth-scroll"
                  :href="base_url + '#testimonial'"
                  >Client</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link smooth-scroll"
                  href="#"
                  target="_blank"
                  >Contact</a
                >
              </li>
            </ul>
          </div>
        </div>
        <div class="col-auto col-lg-2 d-flex justify-content-end ps-0">
          <ul class="social-icons">
            <li class="social-icons-behance">
              <a
                href="#"
                data-bs-toggle="tooltip"
                target="_blank"
                title=""
                data-bs-original-title="Facebook"
              >
                <font-awesome-icon
                  :icon="{ prefix: 'fab', iconName: 'behance' }"
                />
              </a>
            </li>
            <li class="social-icons-dribbble">
              <a
                data-bs-toggle="tooltip"
                href="#"
                target="_blank"
                title=""
                data-bs-original-title="Twitter"
                ><font-awesome-icon
                  :icon="{ prefix: 'fab', iconName: 'dribbble' }"
              /></a>
            </li>
            <li class="social-icons-youtube">
              <a
                data-bs-toggle="tooltip"
                href="https://www.youtube.com/@bhavindabhi9212"
                target="_blank"
                title=""
                data-bs-original-title="Instagram"
                ><font-awesome-icon
                  :icon="{ prefix: 'fab', iconName: 'youtube' }"
              /></a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <!-- Navbar End -->
  </header>
  <!--Header End-->
</template>

<script>
export default {
  name: "TopBarVue",
  data() {
    return {
      base_url: process.env.BASE_URL,
      databs: "",
      datatoggle: "",
      tabs: "",
    };
  },
 
  watch: {
    $route() {
      const bdkeylocal = localStorage.getItem("bdkey");
      if (bdkeylocal !== null) {
        this.datatoggle = "";
        this.tabs = "";
      } else {
        this.datatoggle = "modal";
        this.tabs = "#modalpwd";
      }
    },
  },
};
</script>

<style scoped></style>
